import React from "react";
import { useIntl } from "react-intl";
import PropTypes from "prop-types";
// mui
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
// component
import ButtonMain from "../../../../../../../../../../../common/components/button/ButtonMain";
// img
import feedBackGoodIcon from "../../../../../../../../../../../../images/ai_image/feedBackGood.svg";
import feedBackBadIcon from "../../../../../../../../../../../../images/ai_image/feedBackBad.svg";

export default function FeedBack({ setIsReturnFeedback, setIsFeedBackGood }) {
  const intl = useIntl();

  function handleFeedBack(bool, type) {
    setIsReturnFeedback(true);
    setIsFeedBackGood(bool);
    window.dataLayer.push({
      event:
        type === "negative"
          ? process.env.REACT_APP_GA_NEGATIVE_BUTTON_ID
          : process.env.REACT_APP_GA_POSITIVE_BUTTON_ID,
      type:
        type === "negative"
          ? process.env.REACT_APP_GA_NEGATIVE_BUTTON_ID
          : process.env.REACT_APP_GA_POSITIVE_BUTTON_ID,
    });
  }
  return (
    <Box
      sx={{
        padding: "16px 0",
        marginTop: "16px",
        display: "flex",
        flexDirection: "column",
      }}
      rowGap={1}
    >
      <Box>
        <Typography
          sx={{
            fontSize: "0.875rem",
            fontWeight: "700",
          }}
        >
          {" "}
          {intl.formatMessage({
            id: "sna.sidetool.digitalAITool.ai.AIanalyze.feedback.title",
            defaultMessage: `您覺得分析結果如何？`,
          })}
        </Typography>
      </Box>
      <Box sx={{ display: "flex" }} columnGap={1}>
        <Box>
          {" "}
          <ButtonMain
            buttonProps={{
              text: "分析正確，對我很有幫助",
              onClick: () => handleFeedBack(true, "positive"),
              variant: "feedback",
              startIcon: <img src={feedBackGoodIcon} alt="feedBackGoodIcon" />,
              sx: { padding: "8px 24px 8px 16px", borderRadius: "6px" },
              id: process.env.REACT_APP_GA_POSITIVE_BUTTON_ID,
            }}
          />
        </Box>
        <Box>
          <ButtonMain
            buttonProps={{
              text: "分析錯誤，我要回報",
              onClick: () => handleFeedBack(false, "negative"),
              variant: "feedback",
              startIcon: <img src={feedBackBadIcon} alt="feedBackBadIcon" />,
              sx: { padding: "8px 24px 8px 16px", borderRadius: "6px" },
              id: process.env.REACT_APP_GA_NEGATIVE_BUTTON_ID,
            }}
          />
        </Box>
      </Box>
    </Box>
  );
}
FeedBack.propTypes = {
  setIsReturnFeedback: PropTypes.func,
  setIsFeedBackGood: PropTypes.func,
};
FeedBack.defaultProps = {
  setIsReturnFeedback: PropTypes.func,
  setIsFeedBackGood: PropTypes.func,
};
